"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetStateToString = void 0;
function assetStateToString(assetState) {
    switch (assetState) {
        case null:
            return '-';
        case 'almostEmpty':
            return 'almost empty';
        case 'almostFull':
            return 'almost full';
        case 'armAfterInit':
            return 'arm after init';
        case 'armed':
            return 'armed';
        case 'breached':
            return 'breached';
        case 'closed':
            return 'closed';
        case 'connectionInstable':
            return 'instable connection';
        case 'disabled':
            return 'disabled';
        case 'empty':
            return 'empty';
        case 'error':
            return 'error';
        case 'free':
            return 'free';
        case 'full':
            return 'full';
        case 'init':
            return 'init';
        case 'isMotion':
            return 'is motion';
        case 'isNoMotion':
            return 'no motion';
        case 'maintenance':
            return 'maintenance';
        case 'missingInput':
            return 'missing input';
        case 'needService':
            return 'needs service';
        case 'notify':
            return 'notify';
        case 'occupied':
            return 'occupied';
        case 'ok':
            return 'ok';
        case 'open':
            return 'open';
        case 'operational':
            return 'operational';
        case 'present':
            return 'present';
        case 'shadow':
            return 'shadow';
        case 'test':
            return 'test';
        case 'trigged':
            return 'trigged';
    }
}
exports.assetStateToString = assetStateToString;
//# sourceMappingURL=assetStateToString.js.map